(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-history"] && !Shopify.designMode) return;
  try {
    (() => {
  const panel = document.querySelector('[data-search-history]');
  if (!panel) return;
  const form = panel.closest('form');
  const input = form.querySelector('input[name="q"]');
  const list = panel.querySelector('ul');
  const key = 'humble_search_history_v1';
  let memory = [], storageAvailable = true;
  const clean = value => typeof value === 'string' ? value.trim().replace(/\s+/g, ' ').slice(0, 160) : '';
  const normalize = values => {
    const seen = new Set();
    return (Array.isArray(values) ? values : []).map(clean).filter(value => {
      const id = value.toLocaleLowerCase();
      if (!value || seen.has(id)) return false;
      seen.add(id); return true;
    }).slice(0, 8);
  };
  const read = () => {
    if (storageAvailable) {
      try { memory = normalize(JSON.parse(localStorage.getItem(key) || '[]')); }
      catch { storageAvailable = false; }
    }
    return memory;
  };
  const write = values => {
    memory = normalize(values);
    try { localStorage.setItem(key, JSON.stringify(memory)); }
    catch { storageAvailable = false; }
  };
  const remember = term => { const value = clean(term); if (value) write([value, ...read()]); };
  const svg = path => {
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 24 24'); icon.setAttribute('fill', 'none');
    icon.setAttribute('stroke', 'currentColor'); icon.setAttribute('stroke-width', '1.5');
    icon.setAttribute('stroke-linecap', 'round'); icon.setAttribute('aria-hidden', 'true');
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    line.setAttribute('d', path); icon.append(line); return icon;
  };
  const hide = () => { panel.hidden = true; };
  const render = () => {
    const query = clean(input.value).toLocaleLowerCase();
    const terms = read().filter(term => term.toLocaleLowerCase().includes(query));
    list.replaceChildren();
    terms.forEach((term, index) => {
      const row = document.createElement('li');
      const link = document.createElement('a');
      const url = new URL(form.action, location.origin);
      url.searchParams.set('q', term); url.searchParams.set('type', 'product');
      link.href = url.href;
      const label = document.createElement('span'); label.textContent = term;
      link.append(svg('M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M12 7v5l3 2'), label);
      link.addEventListener('click', () => remember(term));
      const remove = document.createElement('button'); remove.type = 'button';
      remove.setAttribute('aria-label', panel.dataset.removeLabel + ': ' + term);
      remove.title = panel.dataset.removeLabel;
      remove.append(svg('m6 6 12 12M18 6 6 18'));
      remove.addEventListener('click', () => {
        write(read().filter(value => value !== term));
        render();
        const buttons = list.querySelectorAll('button');
        if (buttons.length) buttons[Math.min(index, buttons.length - 1)].focus();
        else input.focus();
      });
      row.append(link, remove); list.append(row);
    });
    panel.hidden = !terms.length || !form.classList.contains('is-open');
  };
  input.addEventListener('focus', render);
  input.addEventListener('input', render);
  form.addEventListener('focusout', event => { if (!form.contains(event.relatedTarget)) hide(); });
  input.addEventListener('keydown', event => {
    if (event.key === 'ArrowDown' && !panel.hidden) { event.preventDefault(); list.querySelector('a')?.focus(); }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); });
  document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) hide(); });
  document.querySelectorAll('form[role="search"]').forEach(searchForm => {
    const field = searchForm.querySelector('input[name="q"]');
    if (!field) return;
    searchForm.autocomplete = 'off'; field.autocomplete = 'off';
    searchForm.addEventListener('submit', () => remember(field.value));
  });
  addEventListener('storage', event => {
    if (event.key === key || event.key === null) {
      storageAvailable = true;
      if (form.contains(document.activeElement)) render();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-features"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.humbleStoreFeatures) return;
  window.humbleStoreFeatures = true;
  const status = document.querySelector('[data-feature-status]');
  const announce = (message) => { if (status && status.textContent !== (message || '')) status.textContent = message || ''; };
  const normalize = (value) => [...new Set(String(value || '').split(',').map(v => v.trim()).filter(v => /^id:\d+$/.test(v)).map(v => v.slice(3)))];
  const read = () => {
    try { return normalize(localStorage.getItem('nt_wis')); }
    catch { announce(status?.dataset.storageError); return null; }
  };
  const sync = () => {
    const ids = read();
    if (!ids) return;
    document.querySelectorAll('[data-favorite-id]').forEach(button => {
      const saved = ids.includes(button.dataset.favoriteId);
      const label = saved ? button.dataset.removeLabel : button.dataset.addLabel;
      if (button.getAttribute('aria-pressed') !== String(saved)) button.setAttribute('aria-pressed', String(saved));
      if (label && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      if (label && button.title !== label) button.title = label;
    });
    document.querySelectorAll('[data-favorite-count]').forEach(count => {
      if (count.textContent !== String(ids.length)) count.textContent = String(ids.length);
      count.hidden = ids.length === 0;
    });
  };
  let page = document.querySelector('[data-favorites-page]');
  let visible = 12;
  let generation = 0;
  const cards = new Map();
  const renderFavorites = async (restoreFocus = false) => {
    page = document.querySelector('[data-favorites-page]');
    if (!page) return;
    const ids = read();
    const progress = page.querySelector('[data-favorites-progress]');
    const total = page.querySelector('[data-favorites-total]');
    if (ids && total) total.textContent = ids.length === 1 ? page.dataset.countOne : page.dataset.countOther.replace('__COUNT__', String(ids.length));
    if (!ids) { progress.textContent = status?.dataset.storageError || ''; return; }
    const version = ++generation;
    const shown = ids.slice(0, visible);
    const grid = page.querySelector('[data-favorites-grid]');
    const retry = page.querySelector('[data-favorites-retry]');
    const more = page.querySelector('[data-favorites-more]');
    retry.hidden = true;
    more.hidden = true;
    page.querySelector('[data-favorites-empty]').hidden = ids.length > 0;
    progress.textContent = shown.length ? page.dataset.loading : '';
    grid.setAttribute('aria-busy', 'true');
    try {
      const missing = shown.filter(id => !cards.has(id));
      for (let offset = 0; offset < missing.length; offset += 12) {
        const batch = missing.slice(offset, offset + 12);
        const url = new URL(page.dataset.searchUrl, location.origin);
        url.searchParams.set('view', 'wish-items');
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[unavailable_products]', 'last');
        url.searchParams.set('q', batch.map(id => 'id:' + id).join(' OR '));
        const response = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('favorites');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = doc.querySelector('[data-favorite-results]');
        if (!results) throw new Error('favorites');
        if (version !== generation || !page.isConnected) return;
        batch.forEach(id => cards.set(id, null));
        results.querySelectorAll('[data-favorite-card-id]').forEach(card => {
          if (batch.includes(card.dataset.favoriteCardId)) cards.set(card.dataset.favoriteCardId, card.outerHTML);
        });
      }
      if (version !== generation || !page.isConnected) return;
      grid.replaceChildren();
      shown.forEach(id => {
        if (cards.get(id)) grid.insertAdjacentHTML('beforeend', cards.get(id));
        else {
          const article = document.createElement('article');
          article.className = 'product-card favorites-unavailable';
          const text = document.createElement('p');
          text.textContent = page.dataset.unavailable;
          const remove = document.createElement('button');
          remove.type = 'button'; remove.className = 'feature-button';
          remove.dataset.favoriteId = id;
          remove.dataset.removeLabel = page.dataset.remove;
          remove.textContent = page.dataset.remove;
          article.append(text, remove); grid.append(article);
        }
      });
      progress.textContent = '';
      more.hidden = shown.length >= ids.length;
      sync();
      if (restoreFocus) page.querySelector('h1')?.focus({ preventScroll: true });
    } catch {
      if (version === generation) { progress.textContent = page.dataset.error; retry.hidden = false; }
    } finally { if (version === generation) grid.setAttribute('aria-busy', 'false'); }
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-favorite-id]');
    if (button) {
      event.preventDefault();
      const ids = read();
      if (!ids || !/^\d+$/.test(button.dataset.favoriteId)) return;
      const id = button.dataset.favoriteId;
      const existed = ids.includes(id);
      const next = existed ? ids.filter(v => v !== id) : [...ids, id];
      try { localStorage.setItem('nt_wis', next.map(v => 'id:' + v).join(',')); }
      catch { announce(status?.dataset.storageError); return; }
      sync(); announce(existed ? status?.dataset.removed : status?.dataset.added);
      await renderFavorites(Boolean(button.closest('[data-favorites-grid]')));
    }
    if (event.target.closest('[data-favorites-more]')) { visible += 12; await renderFavorites(); }
    if (event.target.closest('[data-favorites-retry]')) await renderFavorites();
    const copy = event.target.closest('[data-share-url]');
    if (copy) {
      try { await navigator.clipboard.writeText(copy.dataset.shareUrl); announce(status?.dataset.copied); }
      catch { announce(status?.dataset.copyError); }
    }
  });
  addEventListener('storage', event => { if (event.key === 'nt_wis' || event.key === null) { sync(); void renderFavorites(); } });
  addEventListener('pageshow', () => { sync(); void renderFavorites(); });
  const initializedNotes = new WeakSet();
  const initializeNotes = () => document.querySelectorAll('[data-cart-note]').forEach(note => {
    if (initializedNotes.has(note)) return;
    initializedNotes.add(note);
    const form = note.form;
    const state = form.querySelector('[data-note-status]');
    let saved = note.value, pending = Promise.resolve(), timer, nativeSubmit = false;
    const save = () => {
      pending = pending.catch(() => {}).then(async () => {
        if (note.value === saved) return;
        const value = note.value;
        state.textContent = state.dataset.saving;
        const response = await fetch(note.dataset.saveUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: value }) });
        if (!response.ok) throw new Error('note');
        const cart = await response.json();
        if (cart.note !== value && !(cart.note == null && value === '')) throw new Error('note');
        saved = value;
        state.textContent = state.dataset.saved;
      }).catch(() => { state.textContent = state.dataset.error; });
      return pending;
    };
    note.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(save, 400); });
    note.addEventListener('change', () => { clearTimeout(timer); void save(); });
    form.addEventListener('submit', async event => {
      if (nativeSubmit) { nativeSubmit = false; return; }
      event.preventDefault(); clearTimeout(timer);
      const submitter = event.submitter;
      await save();
      setTimeout(() => {
        if (!form.isConnected) return;
        nativeSubmit = true;
        form.requestSubmit(submitter);
      }, 0);
    });
  });
  const syncVariant = form => {
    const variants = JSON.parse(form.querySelector('[data-variants-json]')?.textContent || '[]');
    const id = form.querySelector('[name="id"]')?.value;
    const variant = variants.find(v => String(v.id) === id);
    if (!variant) return;
    const section = form.closest('.shopify-section');
    const panel = section?.querySelector('[data-restock-panel]');
    if (panel) {
      panel.hidden = variant.available && !panel.querySelector('[data-restock-feedback]');
      const field = panel.querySelector('[data-restock-variant-input]');
      if (field) field.value = variant.title;
      const label = panel.querySelector('[data-restock-variant]');
      if (label) label.textContent = variant.title === 'Default Title' ? '' : variant.title;
      const url = panel.querySelector('[data-restock-url]');
      if (url) url.value = panel.dataset.productUrl + '?variant=' + variant.id;
      const returnTo = panel.querySelector('[name="return_to"]');
      if (returnTo) returnTo.value = new URL(panel.dataset.productUrl).pathname + '?variant=' + variant.id + '#' + panel.querySelector('form').id;
      panel.querySelectorAll('input,button').forEach(field => { field.disabled = panel.hidden; });
    }
    const stockStatus = form.querySelector('[data-stock-status]');
    if (stockStatus) stockStatus.hidden = variant.available;
    const purchaseButton = form.querySelector('.product-action');
    if (purchaseButton) purchaseButton.hidden = !variant.available;
    const quantityGroup = form.querySelector('.product-quantity');
    if (quantityGroup) quantityGroup.hidden = !variant.available;
    const quantity = form.querySelector('[name="quantity"]');
    if (quantity) {
      const limits = JSON.parse(form.querySelector('[data-variant-limits]')?.textContent || '{}');
      const max = limits[id];
      if (max == null) quantity.removeAttribute('max'); else quantity.max = String(Math.max(0, max));
      quantity.disabled = !variant.available;
      if (max > 0 && Number(quantity.value) > max) quantity.value = String(max);
      quantity.dispatchEvent(new Event('input', { bubbles: true }));
    }
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) syncVariant(event.target.closest('[data-product-form]'));
  });
  const related = new WeakSet();
  const initialize = () => {
    sync(); initializeNotes();
    document.querySelectorAll('[data-product-form]').forEach(syncVariant);
    document.querySelectorAll('[data-related-products]').forEach(async section => {
      if (related.has(section)) return;
      related.add(section);
      try {
        const leadImage = document.querySelector('.detail-lead img');
        if (leadImage && !leadImage.complete) await leadImage.decode().catch(() => {});
        if (!section.isConnected) return;
        const response = await fetch(section.dataset.url, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('recommendations');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-related-content]');
        if (content && section.isConnected) { section.replaceChildren(content); section.hidden = false; sync(); }
      } catch { related.delete(section); }
    });
  };
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; sync(); });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', () => { initialize(); void renderFavorites(); });
  initialize(); void renderFavorites();
})();
  } catch(e) { console.error(e); }
})();

})();
